import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import { eu, login as apiLogin, salvarToken, limparToken, obterToken } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [usuario, setUsuario] = useState(null); // { email } se logado, null se não
    const [verificando, setVerificando] = useState(true); // true durante check inicial do token

    // Tenta revalidar o token salvo ao montar
    useEffect(() => {
        const t = obterToken();
        if (!t) {
            setVerificando(false);
            return;
        }
        eu().then((r) => setUsuario({ email: r.email }))
            .catch(() => { limparToken(); setUsuario(null); })
            .finally(() => setVerificando(false));
    }, []);

    // Auto-logout quando qualquer chamada retornar 401.
    // Mostra toast informando o motivo APENAS se o usuário estava de fato logado
    // (evita aparecer no carregamento inicial quando o token salvo é inválido).
    useEffect(() => {
        const handler = () => {
            setUsuario((u) => {
                if (u) toast.error("Sessão expirada. Faça login novamente.");
                return null;
            });
        };
        window.addEventListener("auth:nao-autorizado", handler);
        return () => window.removeEventListener("auth:nao-autorizado", handler);
    }, []);

    const entrar = useCallback(async (email, senha) => {
        const r = await apiLogin(email, senha);
        salvarToken(r.token);
        setUsuario({ email: r.email });
    }, []);

    const sair = useCallback(() => {
        limparToken();
        setUsuario(null);
    }, []);

    return (
        <AuthContext.Provider value={{ usuario, verificando, entrar, sair }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth deve estar dentro de AuthProvider");
    return ctx;
}
